<template>
  <div class="header-component ml-4">
    <span>{{ header }}</span>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data: () => ({
    pageName: "",
  }),
  created() {
    // console.log('this.$route', this.$route);
    // this.pageName = this.$store.getters.getPageHeader;
  },
  computed: {
    ...mapGetters({
      header: "getPageHeader",
    }),
    // getHeaderName() {
    //   this.pageName = this.$store.getters.getPageHeader;
    //   return this.$store.getters.getPageHeader;
    // }
  },
};
</script>

<style lang="scss" scoped>
.header-component {
  white-space: nowrap;
  width: 100%;
  display: flex;
  align-items: center;
  span {
    margin-right: -8px;

    color: #55616e;
    font-size: 14px;
    font-weight: bold;
    line-height: 30px;
  }
}
</style>

